"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  budget: {
    budgetManage: 'Budget Management',
    annualBudget: 'Annual Budget',
    annualBudgetDtl: 'Annual Budget Detail',
    noData: 'No Data',
    typeYear: 'Export Year',
    typeMonth: 'Export Month',
    bgtExportType: 'Export Type',
    confirmButton: 'Confirm',
    dept: 'Dept',
    company: 'Company',
    budgetType: 'Budget Type',
    budgetYear: 'Budget Year',
    budgetAmount: 'Total Amount',
    budgetCurrency: 'Budget Currency',
    baseInfo: 'Base Information',
    vesselBudget: 'Vessel Budget',
    currency: 'Currency',
    status: 'Status',
    year: 'Year',
    budgetIptType: 'Budget Input Type',
    summary: 'Summary',
    budgetVersion: 'Budget Version',
    creator: 'Creator',
    createTime: 'Create Time',
    option: 'Operation',
    vesselName: 'Vessel Name',
    amount: 'Amount',
    chargeName: 'Charge Name',
    total: 'Total',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'Septmber',
    october: 'October',
    november: 'November',
    december: 'December',
    remark: 'Remark',
    copy: 'Copy',
    pasted: 'Pasted',
    approved: 'Approved',
    refused: 'Refused',
    apply: 'Apply History',
    btn: {
      budgetCopy: 'Budget Copy',
      exportTemplate: 'Export Template',
      addRemark: 'Add/Edit Remark'
    },
    placeHolder: {
      selectYear: 'Select Year',
      select: 'Please Select'
    },
    budgetControlAnalysis: {
      budgetControlAnalysis: 'Comparative analysis of budget control',
      displayType: 'Contrast latitude',
      sisterShip: 'Sister Ship',
      dateRange: 'Date Range',
      chargeName: 'Business Account',
      queryTips1: 'Please select the contrast latitude',
      queryTips2: 'Cannot query across years'
    },
    tips: {
      versionTip: ' According to the budget adjustment application process, Please upload relevant evidences for approval (such as approval opinions of relevant departments or Minutes of the management meeting)',
      copyTip: 'Please select a record to cop.',
      unDelTip: 'This record cannot be deleted!',
      confirmDel: 'Are you sure to delete the record?',
      confirmSub: 'Are you sure to submit the record?',
      prompt: 'Prompt',
      delSuccess: 'successfully deleted',
      delFail: 'failed to delete',
      saving: 'saving',
      loading: 'loading',
      selectCell: 'Please select a cell and add a note',
      cantSetComment: 'Please note cannot be added to this cell',
      saveSuccess: 'Successfully saved',
      submitSuccess: 'Successfully submitted',
      saveFail: 'Save failed',
      fillOther: 'Please save it before filling in other ships',
      subAgain: 'Do not submit repeatedly',
      copyAddSuccess: 'Successfully copied',
      message: 'Please save the content before submitting',
      notEmpty: 'Can not be empty',
      pleaseSave: 'Please save the annual budget first'
    }
  }
};